export enum CarePlanSignatureTypeEnum {
    Provider = 1,
    Member = 2,
    GuardianOrCareGiver = 3,
    HealthCareDecisionMaker = 4,
    VerbalConsent = 5,
    CheckboxReview = 6,
}
